
  import { Fragment, useState } from "react";
import useFetchOtherDocuments from "../Utils/useFetchOtherDocuments";
import { FaRegFile } from "react-icons/fa";
import { MdDone } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiWarning } from "react-icons/ci";
import useOtherDocumentDeletion from "../Utils/useOtherDocumentDeletion";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "react-loading-skeleton/dist/skeleton.css";

const OtherDocuments = ({ vesselId }) => {
  const { data, isLoading, isError, error } = useFetchOtherDocuments(vesselId);
  const {
    deleting,
    selectedOtherDocuments,
    setSelectedOtherDocuments,
    deleteOtherDocuments,
  } = useOtherDocumentDeletion(vesselId);
  const [deleteOtherDocOverlay, setOtherDocDeleteOverlay] = useState(false);
  const { otherDocuments } = data?.data || {};
  const [collapsedSections, setCollapsedSections] = useState({
    otherDocuments: true,
  });
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleDocumentSelect = (document) => {
    if (selectedOtherDocuments.includes(document)) {
      setSelectedOtherDocuments(
        selectedOtherDocuments.filter((doc) => doc !== document)
      );
    } else {
      setSelectedOtherDocuments([...selectedOtherDocuments, document]);
    }
  };

  const handleDeleteOtherDocument = async () => {
    if (selectedOtherDocuments.length === 0) {
      toast.error("Please select at least one document to delete.");
      return;
    }

    try {
      const documentsToDelete = selectedOtherDocuments.map(({ _id, ...rest }) => rest);

      const formattedData = {
        otherDocuments: documentsToDelete, 
      };

      console.log(formattedData)

      await deleteOtherDocuments(vesselId, formattedData);
      setOtherDocDeleteOverlay(false);
      setSelectedOtherDocuments([]);
    } catch (error) {
      toast.error("An error occurred while deleting other documents.");
    }
  };

  const handleViewPdf = (url) => {
    setPdfUrl(url);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setPdfUrl("");
  };

  return (
    <Fragment>
      {deleteOtherDocOverlay && (
        <div className="delete-details-overlay">
          <div className="card">
            <CiWarning className="warning" />
            <h2>Delete</h2>
            <p>Are you sure you want to delete the selected document(s)?</p>
            <div className="btn">
              <button
                onClick={() => {
                  setSelectedOtherDocuments([]);
                  setOtherDocDeleteOverlay(false);
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteOtherDocument}
                disabled={deleting || selectedOtherDocuments.length === 0}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPdfModal && (
        <div className="modal-overlay" onClick={closePdfModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <Viewer fileUrl={pdfUrl} />
            </Worker>
          </div>
            <button className="close-btn" onClick={closePdfModal}>
              Close
            </button>
        </div>
      )}

      <div className="myvessel-details-container">
        <div className="info" onClick={() => toggleSection("otherDocuments")}>
          <p>Other Documents</p>
          {collapsedSections.otherDocuments ? (
            <IoIosArrowDown />
          ) : (
            <IoIosArrowUp />
          )}
        </div>

        {!collapsedSections.otherDocuments && (
          <div className="card">
            {isLoading ? (
              <>
                <Skeleton
                  count={1}
                  height={30}
                  width={300}
                  style={{ marginBottom: "20px" }}
                />
                <Skeleton count={3} height={200} />
              </>
            ) : isError ? (
              <div>Error: {error.message}</div>
            ) : (
              <>
                {otherDocuments && otherDocuments.length > 0 ? (
                  otherDocuments.map((doc, index) => (
                    <div key={index} className="file-preview">
                      <div className="first">
                        <FaRegFile className="file" />
                        <span>{doc.name}</span>
                      </div>
                      <div className="second">
                        <MdDone className="done" />
                        <button
                          onClick={() => handleDocumentSelect(doc)}
                          className={`select-button ${
                            selectedOtherDocuments.includes(doc)
                              ? "selected"
                              : ""
                          }`}
                        >
                          {selectedOtherDocuments.includes(doc)
                            ? "Selected"
                            : "Select"}
                        </button>
                        <button
                         onClick={() => handleViewPdf(doc.fileUrl)}>
                          View
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="images-error">
                    No other documents available.
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {!collapsedSections.otherDocuments &&
          otherDocuments &&
          otherDocuments.length > 0 && (
            <button
              onClick={() => setOtherDocDeleteOverlay(true)}
              disabled={selectedOtherDocuments.length === 0}
              className="btn"
            >
              Delete Selected Documents
            </button>
          )}
        <ToastContainer />
      </div>
    </Fragment>
  );
};

export default OtherDocuments;

